<template>
    <div class="stream-menu-wrapper">
        <button class="icon-btn" type="button" aria-label="Stream" :aria-expanded="visible" @click="$emit('toggle')">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"> <path d="M12 4L12 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M4 8L6.5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M17.5 10.5L20 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M3 17H6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M12 17L13 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M18 17H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M8.5 20.001H4C2.74418 18.3295 2 16.2516 2 14C2 8.47715 6.47715 4 12 4C17.5228 4 22 8.47715 22 14C22 16.2516 21.2558 18.3295 20 20.001L15.5 20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M12 23C13.6569 23 15 21.6569 15 20C15 18.3431 13.6569 17 12 17C10.3431 17 9 18.3431 9 20C9 21.6569 10.3431 23 12 23Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
        </button>

        <transition name="stream-menu">
            <div class="stream-menu" v-if="visible" @click.stop>
                <div class="stream-menu-arrow"></div>
                <div class="stream-menu-header">Streams</div>
                <div class="stream-menu-list"  v-touch:touchhold="() => {showfull = !showfull}">
                    <button
                        v-for="stream in streams"
                        :key="stream.link"
                        type="button"
                        class="stream-menu-item"
                        :class="{ 'is-active': activeStream && activeStream.link === stream.link }"
                        @click="$emit('change-stream', stream)"
                    >
                        <span class="stream-menu-item-name" :title="stream.fullname || stream.name">{{ showfull ? (stream.fullname || stream.name) : stream.name }}</span>
                        <span class="stream-menu-item-dot" v-if="activeStream && activeStream.link === stream.link"></span>
                    </button>
                </div>

                <div class="stream-menu-divider"></div>

                <div class="stream-menu-header">Playback Speed</div>
                <div class="stream-menu-list">
                    <button
                        v-for="rate in playbackRates"
                        :key="rate"
                        type="button"
                        class="stream-menu-item"
                        :class="{ 'is-active': currentPlaybackRate === rate }"
                        @click="$emit('change-playback-rate', rate)"
                    >
                        <span class="stream-menu-item-name">{{ rate }}x</span>
                        <span class="stream-menu-item-dot" v-if="currentPlaybackRate === rate"></span>
                    </button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'StreamMenu',
    props: {
        visible: { type: Boolean, default: false },
        streams: { type: Array, default: () => [] },
        activeStream: { type: Object, default: null },
        playbackRates: { type: Array, default: () => [0.5, 1, 1.5, 2] },
        currentPlaybackRate: { type: Number, default: 1 },
    },
    data(){
        return{
            showfull: false
        }
    }
}
</script>

<style lang="scss" scoped>
.stream-menu-wrapper {
    position: relative;
    display: inline-flex;
}

.stream-menu {
    position: absolute;
    bottom: calc(100% + 32px);
    left: -50px;
    transform: translateX(-50%);
    z-index: 20;
    width: 236px;
    max-width: 80vw;
    background: rgba(40, 40, 42, 0.92);
    backdrop-filter: blur(18px) saturate(1.4);
    -webkit-backdrop-filter: blur(18px) saturate(1.4);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 8px;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5), 0 2px 8px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.06);
    padding: 6px;
    transform-origin: bottom center;
    overflow: hidden;

    .stream-menu-arrow {
        position: absolute;
        bottom: -5px;
        left: 50%;
        transform: translateX(-50%) rotate(45deg);
        width: 10px;
        height: 10px;
        background: rgba(40, 40, 42, 0.92);
        border-right: 1px solid rgba(255, 255, 255, 0.08);
        border-bottom: 1px solid rgba(255, 255, 255, 0.08);
        border-radius: 0 0 2px 0;
    }

    .stream-menu-header {
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.6px;
        text-transform: uppercase;
        color: rgba(255, 255, 255, 0.45);
        padding: 8px 10px 6px;
    }

    .stream-menu-divider {
        height: 1px;
        margin: 6px 4px;
        background: rgba(255, 255, 255, 0.08);
    }

    .stream-menu-list {
        max-height: 216px;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: 2px;
        padding-right: 2px;

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-track {
            background: transparent;
        }

        &::-webkit-scrollbar-thumb {
            background: rgba(255, 255, 255, 0.15);
            border-radius: 3px;

            &:hover {
                background: rgba(255, 255, 255, 0.28);
            }
        }
    }

    .stream-menu-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        width: 100%;
        background: none;
        border: none;
        border-radius: 8px;
        padding: 9px 10px;
        color: rgba(255, 255, 255, 0.85);
        font-size: 13.5px;
        font-weight: 500;
        text-align: left;
        cursor: pointer;
        transition: background 0.15s ease, color 0.15s ease;

        &:hover {
            background: rgba(255, 255, 255, 0.08);
            color: #fff;
        }

        &:active {
            background: rgba(255, 255, 255, 0.12);
        }

        &.is-active {
            color: #fff;
            font-weight: 600;
            background: rgba(255, 255, 255, 0.2);

        }
    }

    .stream-menu-item-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .stream-menu-item-dot {
        flex-shrink: 0;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: #2ecc71;
        box-shadow: 0 0 0 3px rgba(39, 174, 96, 0.2);
    }
}
</style>
